import PropTypes from "prop-types"
import { useEffect, useLayoutEffect, useRef } from "react"
import { connect } from "react-redux"

import withTotalItemPrice from "areas/product/hoc/with-total-item-price"
import { addToCart, setFixedATC } from "areas/product/store/actions"
import Button from "components/ui/button"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"
import useWindowDimensions from "helpers/window-dimensions"
import { cn } from "styles/utils"

const InternalAddToCartButton = ({
  addToCart,
  fixedATC,
  header,
  isAddingToCart,
  lid,
  prefStore,
  setFixedATC,
  totalItemPrice,
  wizardLoading,
  wizardRef,
}) => {
  const { isMobile } = useWindowDimensions()
  const cancelled = useRef(false)

  const cartStr = jewlr_t("Cart")

  useLayoutEffect(() => {
    const addToCartScrollTick = () => {
      if (!cancelled.current) {
        if (isMobile) {
          window.requestAnimationFrame(() => {
            if (wizardRef.current) {
              const rect = wizardRef.current.getBoundingClientRect()
              if (!rect) return

              setFixedATC(rect.bottom <= 0)
            }
          })
        } else {
          setFixedATC(false)
        }
      }
    }

    addToCartScrollTick()
    window.addEventListener("scroll", addToCartScrollTick, false)

    return () =>
      window.removeEventListener("scroll", addToCartScrollTick, false)
  }, [isMobile, wizardRef.current])

  useEffect(() => {
    return () => (cancelled.current = true)
  }, [])

  return (
    <div
      className={cn(
        fixedATC
          ? "z-2 tablet:shadow-none tablet:static tablet:w-auto tablet:p-0 shadow-(--box-shadow) fixed bottom-0 left-0 w-full bg-white p-16"
          : "mb-20"
      )}
      style={{ "--box-shadow": "0 -4px 4px 0 rgba(0, 0, 0, 0.15)" }}
    >
      <Button
        className="js-add-cart text-18 w-full"
        data-cy="product-wizard-add-to-cart-btn"
        disabled={!prefStore || isAddingToCart || wizardLoading}
        loading={isAddingToCart}
        onClick={(e) => addToCart(e, isAddingToCart)}
        rel="nofollow"
        type="submit"
        variant="secondary"
      >
        {isMobile && <>{to_currency(totalItemPrice)} &ndash; </>}
        {header.params_olid_present
          ? "Update Order"
          : lid
            ? isAddingToCart
              ? `Updating ${cartStr}...`
              : `Update ${cartStr}`
            : isAddingToCart
              ? `Adding to ${cartStr}...`
              : `Add to ${cartStr}`}
      </Button>
    </div>
  )
}

InternalAddToCartButton.propTypes = {
  addToCart: PropTypes.func,
  fixedATC: PropTypes.bool,
  header: PropTypes.object,
  isAddingToCart: PropTypes.bool,
  lid: PropTypes.string,
  prefStore: PropTypes.bool,
  setFixedATC: PropTypes.func,
  totalItemPrice: PropTypes.number,
  wizardLoading: PropTypes.string,
  wizardRef: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    fixedATC: state.wizardUI.fixedATC,
    header: state.wizard.header,
    isAddingToCart: state.wizardUI.isAddingToCart,
    lid: state.wizardUI.lid,
    prefStore: state.wizardUI.prefStore,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (e, isAddingToCart) => {
      e.preventDefault()
      if (!isAddingToCart) {
        dispatch(addToCart())
      }
    },
    setFixedATC: (fixed) => dispatch(setFixedATC(fixed)),
  }
}

const AddToCartButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAddToCartButton)

export default withTotalItemPrice(AddToCartButton)
